import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
    DetailContainer,
    DetailPart,
    HeaderContainer,
    ImgContainer,
    IngredContainer,
    OtherPart,
} from "./DetailsStyles";
import dietsvg from "../../assets/diet.svg";

const Details = () => {
    const location = useLocation();
    console.log(location.state.recipe.recipe);
    const recipe = location.state.recipe.recipe;

    const [showAllLabels, setShowAllLabels] = useState(false);

    const showMore = () => {
        setShowAllLabels(true);
    };

    const showLess = () => {
        setShowAllLabels(false);
    };

    const healthLabelsToShow = showAllLabels
        ? recipe.healthLabels
        : recipe.healthLabels.slice(0, 5);

    return (
        <DetailContainer>
            <HeaderContainer>
                <h1>{recipe.label}</h1>
                <img src={dietsvg} alt="img" />
            </HeaderContainer>
            <DetailPart>
                <OtherPart>
                    <>Nutrients</>
                    <p>Dish type : {recipe.dishType} </p>
                    <p>Meal type : {recipe.mealType} </p>
                    <p>
                        {recipe.totalNutrients.CHOLE.label} :{" "}
                        {Math.round(recipe.totalNutrients.CHOLE.quantity)}{" "}
                        {recipe.totalNutrients.CHOLE.unit}
                    </p>
                    <p>
                        {recipe.totalNutrients.ENERC_KCAL.label} :{" "}
                        {Math.round(recipe.totalNutrients.ENERC_KCAL.quantity)}{" "}
                        {recipe.totalNutrients.ENERC_KCAL.unit}
                    </p>
                    <p>Total weight : {Math.round(recipe.totalWeight)} g</p>
                    <a
                        href={recipe.url}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            cursor: "pointer",
                            color: "green",
                            textDecoration: "underline",
                        }}
                    >
                        For more info...
                    </a>
                    <h3>Health Labels</h3>
                    <div>
                        {healthLabelsToShow.map((item, index) => (
                            <p key={index}>
                                {" "}
                                {index + 1} - {item}{" "}
                            </p>
                        ))}
                        {!showAllLabels && recipe.healthLabels.length > 5 && (
                            <p
                                style={{ cursor: "pointer", color: "red" }}
                                onClick={showMore}
                            >
                                Show more...
                            </p>
                        )}
                        {showAllLabels && (
                            <p
                                style={{ cursor: "pointer", color: "red" }}
                                onClick={showLess}
                            >
                                Show less...
                            </p>
                        )}
                    </div>
                </OtherPart>
                <ImgContainer>
                    <img src={recipe.image} alt="img" />
                </ImgContainer>
                <IngredContainer>
                    {recipe.ingredientLines.map((item, index) => (
                        <div key={index}>
                            <p>
                                {index + 1} =&gt; {item}{" "}
                            </p>
                        </div>
                    ))}
                </IngredContainer>
            </DetailPart>
        </DetailContainer>
    );
};

export default Details;
